module.exports = __webpack_public_path__ + "img/hands.39d3812c.png";